import { render, staticRenderFns } from "./EditorBlock.vue?vue&type=template&id=581cc8c4&scoped=true&"
import script from "./EditorBlock.vue?vue&type=script&lang=js&"
export * from "./EditorBlock.vue?vue&type=script&lang=js&"
import style0 from "./EditorBlock.vue?vue&type=style&index=0&id=581cc8c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581cc8c4",
  null
  
)

export default component.exports